import React from 'react';
import { FormLink } from '../../../types/forms';
import FormFieldTooltip from './FormFieldTooltip';
import PopUpFormLink, { PopupFormSavedData } from './PopUpFormLink';

type Props = {
    links: FormLink[];
    onPopupSaved?: (data: PopupFormSavedData) => void;
};

const FormFieldLinks = ({ links, onPopupSaved }: Props) => {
    return (
        <>
            {links.map((link, index) => {
                const key = `${link.type}-${link.url}-${index}`;

                if (link.type === 'text') {
                    return (
                        <FormFieldTooltip
                            key={key}
                            url={link.url}
                            linkType="text"
                        />
                    );
                }

                if (link.type === 'infolink') {
                    return (
                        <FormFieldTooltip
                            key={key}
                            url={link.url}
                            linkType="infolink"
                        />
                    );
                }

                if (link.type === 'popuplink') {
                    return (
                        <PopUpFormLink
                            key={key}
                            url={link.url}
                            onSaved={onPopupSaved ?? (() => {})}
                        />
                    );
                }

                return null;
            })}
        </>
    );
};

export default FormFieldLinks;